import { createContext, useContext } from 'react';

import { ColorScheme, ThemePreference } from 'helpers/theme';

import { LIGHT_COLORS, ThemeColors } from 'styles/style-constants';

export interface ThemeContextValue {
    preference: ThemePreference;
    theme: ColorScheme;
    colors: ThemeColors;
    setPreference: (preference: ThemePreference) => void;
}

export const ThemeContext = createContext<ThemeContextValue>({
    preference: 'system',
    theme: 'light',
    colors: LIGHT_COLORS,
    setPreference: () => undefined,
});

const useTheme = () => useContext(ThemeContext);

export default useTheme;
